<template>
    <div class="toast" v-if="show">
      <span>{{msg}}</span>
    </div>
</template>

<script>
export default {
  name: 'ToastShow'
}
</script>

<style scoped lang="less">
  .toast {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 5rem;
    padding: 0 1.9rem;
    text-align: center;
    width: 100%;
    z-index: 9999;
    span {
      font-size: 1.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #D1D1D1;
      line-height: 1.3rem;
      background: #272F41;
      border-radius: 4px;
      padding: 1.5rem;
    }
  }
</style>
